/* 초기 비밀번호(0000)로 로그인한 계정은 본인 비밀번호를 정하기 전에는 아무 화면도 못 쓴다.
   서버가 진짜 차단(403 PASSWORD_SETUP_REQUIRED)을 하고, 이 표시는 «온보딩 창을 띄울지»만 정한다.
   그래서 이 값을 지워도 서버가 다시 막고, 그 403 이 이 표시를 다시 세운다. */
const STORAGE_FLAG = 'mustChangePassword';
export const PASSWORD_SETUP_EVENT = 'password-setup-change';
export const PASSWORD_SETUP_CODE = 'PASSWORD_SETUP_REQUIRED';
// 서버가 온보딩 중에 «지금 비밀번호»로 받는 값(서버 INITIAL_PASSWORD 와 같아야 한다)
export const INITIAL_PASSWORD = '0000';

export const needsPasswordSetup = () => localStorage.getItem(STORAGE_FLAG) === '1';

export const setPasswordSetup = (required) => {
  if (required) localStorage.setItem(STORAGE_FLAG, '1');
  else localStorage.removeItem(STORAGE_FLAG);
  window.dispatchEvent(new Event(PASSWORD_SETUP_EVENT));
};
